import React from 'react'
import moment from "moment";

export const getAssayValuesFromHistory = (history) => {
    const isMedis = process.env.REACT_APP_CURRENT_CLINIC === "MEDIS";

    const assayValues = history.map(item => {
        return {result: item.result, state: item.state === "normal" ? isMedis  ? '#00b3a1' : '#0077C8' : item.state === "critical" ? "rgb(255,33,33)" : '#fff300', date: moment(item.date)}
    }).sort((a, b) => {
        return new Date(a.date.format("YYYY/MM/DD")) - new Date(b.date.format("YYYY/MM/DD"))
    })

    // assayValues.unshift({result: "13", state: "rgb(255,33,33)", date: assayValues[0].date})
    // assayValues.push({result: "15", state: "rgb(255,33,33)", date: assayValues[1].date})

    let min = 1000;
    let max = 0;
    let minYear = new Date().getFullYear() + 1
    let maxYear = 1900

    assayValues.map((item) => {
        min = Number(item.result) < min ? Number(item.result) : min
        max = Number(item.result) > max ? Number(item.result) : max
        minYear = moment(item.date).year() < minYear ? moment(item.date).year() : minYear
        maxYear = moment(item.date).year() > maxYear ? moment(item.date).year() : maxYear
    })

    return {assayValues, min, max, minYear, maxYear}
}

export const getChartOptions = (assay) => {
    const {min, max} = assay
    const isMedis = process.env.REACT_APP_CURRENT_CLINIC === "MEDIS";

    return {
        scales: {
            y: {
                suggestedMin: min - (max !== min ? (max - min) : 5),
                suggestedMax: max + (max !== min ? (max - min) : 5),
                ticks: {
                    stepSize: 1
                }
            },
        },
        responsive: true,
        plugins: {
            tooltip: {
                backgroundColor: 'white',
                titleColor: isMedis ? '#00b3a1' : '#0077C8',
                bodyColor: isMedis ? '#00b3a1' : '#0077C8',
                borderColor: isMedis ? '#00b3a1' : '#0077C8',
                borderWidth: 2,
                displayColors: false
            },
            legend: {
                display: false
            },
            title: {
                display: true,
                text: "  Результати", //+ research.units,
                color: isMedis ? '#00b3a1' : '#0077C8',
                align: 'start',
                padding: {
                    top: 10,
                    bottom: 20,
                },
                font: {size: '17px', weight: 500, textDecoration: 'uppercase'},
            },
            annotation: {
                annotations: {
                    // box1: {
                    //     type: "box",
                    //     drawTime: "beforeDatasetsDraw",
                    //     xMin: minYear - 1,
                    //     xMax: maxYear + 1,
                    //     yMin: min - (max !== min ? (max - min) : 1),
                    //     yMax: max + (max !== min ? (max - min) : 1),
                    //     backgroundColor: 'rgba(187,224,255,0.5)',
                    //     xScaleID: 'x-axis-0'
                    // },
                    // line1: {
                    //     type: 'line',
                    //     yMin: min - (max !== min ? (max - min) : 1),
                    //     yMax: min - (max !== min ? (max - min) : 1),
                    //     borderColor: 'rgba(53, 162, 235, 0.5)',
                    //     borderWidth: 2,
                    //     shadowBlur: 10
                    // },
                    // line2: {
                    //     type: 'line',
                    //     yMin: max + (max !== min ? (max - min) : 1),
                    //     yMax: max + (max !== min ? (max - min) : 1),
                    //     borderColor: 'rgba(53, 162, 235, 0.5)',
                    //     borderWidth: 2,
                    //     shadowBlur: 10
                    // }
                    // } : {
                    //     line1: {
                    //         type: 'line',
                    //         yMin: 0,
                    //         yMax: 0,
                    //         borderColor: 'rgba(53, 162, 235, 0.5)',
                    //         borderWidth: 2,
                    //         shadowBlur: 10
                    //     },
                    //     label1: {
                    //         type: 'label',
                    //         xValue: Number(dates.slice(0, 4)),
                    //         yValue: assayValues.split("~").at(0).replace("\"", "").toLowerCase().includes("не") ? 5 : -5,
                    //         backgroundColor: 'rgb(255,255,255)',
                    //         content: [assayValues.split("~").at(0).replace("\"", "").toLowerCase().includes("не") ? "Не виявлено" : "Виявлено"],
                    //         color: assayValues.split("~").at(0).replace("\"", "").toLowerCase().includes("не") ? isMedis ? '#00b3a1' : '#0077C8' : 'rgb(255,33,33)',
                    //         font: {
                    //             size: 17
                    //         },
                    //         xScaleID: 'x-axis-0'
                    //     }
                    // }
                }
            }
        }
    }
}

function getGradient(ctx, chartArea, assayValues) {
    let gradient;
    if (!gradient) {
        gradient = ctx.createLinearGradient(chartArea.left, 0, chartArea.right, 0);
        gradient.addColorStop(0, assayValues[0].state);
        assayValues.map((item, idx) => {
            gradient.addColorStop((1 / (assayValues.length + 1)) * (idx + 1), item.state);
        })
        gradient.addColorStop(1, assayValues.at(-1).state);

        // gradient.addColorStop(0, "rgb(255,33,33)");
        // gradient.addColorStop(0.25, "rgb(255,33,33)");
        // gradient.addColorStop(0.5, '#0077C8');
        // gradient.addColorStop(0.75, "rgb(255,33,33)");
        // gradient.addColorStop(1, '#0077C8');
    }

    return gradient;
}

export const getChartData = (assay) => {
    const {assayValues, minYear, maxYear} = assay

    const colors = assayValues.map(item => item.state)

    return {
        labels: Array.of(minYear - 1, ...assayValues.map(item => {
            return item.date.format("YYYY/MM/DD")
        }), maxYear + 1),
        datasets: [
            {
                label: 'Результати',
                data: Array.of(null, ...assayValues.map(item => {
                    return item.result
                }), null),
                borderColor: function(context) {
                    const chart = context.chart;
                    const {ctx, chartArea} = chart;

                    if (!chartArea) {
                        return;
                    }
                    return getGradient(ctx, chartArea, assayValues);
                },
                borderWidth: 3,
                pointBackgroundColor: '#ffffff',
                // pointBorderColor: isMedis ? '#00b3a1' : '#0077C8', //research.state === "normal" ? '#00b3a1' : "rgb(255,33,33)",
                pointBorderColor: Array.of(null, ...colors, null),
                // pointHoverBackgroundColor: isMedis ? '#00b3a1' : '#0077C8', //research.state === "normal" ? '#00b3a1' : "rgb(255,33,33)",
                pointHoverBackgroundColor: Array.of(null, ...colors, null),
                pointHoverBorderColor: "#fff",
                pointRadius: 6,
                pointHoverRadius: 8,
                fill: false,
                order: 2
            },
        ]
    }
};